import './ImagesSlider.scss'
import {useRef,useState,useEffect} from "react";
import {
    ModalCloseIcon,
    SliderLeftArrIcon,
    SliderRightArrIcon
} from "../../../../assets/images";
import {Modal} from "antd";
import { Navigation, Pagination} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/react";
import {generateFileMediaUrl} from "../../../../utils/generateMediaUrl";

function ImagesSlider(props){
    const {closeModal, visible, modalImagePathList, modalCurrentImageIndex} = props;
    const [slideIndex, setSlideIndex] = useState(0);
    let sliderRef = useRef(null);
    const swiperRef = useRef(null);

    useEffect(() => {
        if(!!visible){
            setSlideIndex(0)
        }
    }, [visible])

    useEffect(() => {
        sliderRef.slickGoTo?.(modalCurrentImageIndex)
        setSlideIndex(modalCurrentImageIndex)
    }, [modalCurrentImageIndex])

    const nextSlide = (index) => {
        setSlideIndex(index + 1 === modalImagePathList?.length ? 0 : index + 1)
    };

    const prevSlide = (index) => {
        setSlideIndex(index === 0 ? modalImagePathList?.length - 1 : index - 1)
    };


    return <Modal
        visible={visible}
        wrapClassName={'custom-modal'}
        transitionName={""}
        centered={true}
        closeIcon={<ModalCloseIcon/>}
        maskClosable={false}
        onCancel={closeModal}>
        <div className={'slider-modal-wrapper'}>
            {!!modalImagePathList?.length && <Swiper
                spaceBetween={25}
                slidesPerView={1}
                pagination={{ clickable: true }}
                navigation
                modules={[Pagination, Navigation]}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                centeredSlides={true}
            >
                {modalImagePathList?.map((item, index) => {
                    if(index === slideIndex){
                        return <SwiperSlide key={item.id}>
                            <div className={`modal-slider-wrapper`}>
                                <img src={generateFileMediaUrl(item?.path)} className={'about-img'}
                                     onClick={() => setSlideIndex(index)} alt={"about"}/>
                            </div>
                        </SwiperSlide>
                    }
                })}
            </Swiper>}
            {
                modalImagePathList?.length > 1 ?  <>
                    <button className={`slider-btn  prev-btn`}
                            onClick={() => prevSlide(slideIndex)}
                    >
                        <SliderLeftArrIcon/>
                    </button>
                    <button
                        className={`slider-btn next-btn`}
                        onClick={() => nextSlide(slideIndex)}>
                        <SliderRightArrIcon/>
                    </button>
                </> : ''
            }
        </div>
    </Modal>
}export default ImagesSlider